(function () {
  'use strict';
  var patterns = '212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 221312 231212 112232 122132 122231 113222 123122 123221 223211 221132 221231 213212 223112 312131 311222 321122 321221 312212 322112 322211 212123 212321 232121 111323 131123 131321 112313 132113 132311 211313 231113 231311 112133 112331 132131 113123 113321 133121 313121 211331 231131 213113 213311 213131 311123 311321 331121 312113 312311 332111 314111 221411 431111 111224 111422 121124 121421 141122 141221 112214 112412 122114 122411 142112 142211 241211 221114 413111 241112 134111 111242 121142 121241 114212 124112 124211 411212 421112 421211 212141 214121 412121 111143 111341 131141 114113 114311 411113 411311 113141 114131 311141 411131 211412 211214 211232 2331112'.split(' ').map(function (p) { return p.split('').map(Number); });
  var left = ['0001101','0011001','0010011','0111101','0100011','0110001','0101111','0111011','0110111','0001011'];
  var parity = ['LLLLLL','LLGLGG','LLGGLG','LLGGGL','LGLLGG','LGGLLG','LGGGLL','LGLGLG','LGLGGL','LGGLGL'];
  function match(runs, offset, ids) {
    var best = null, error = 0.23;
    ids.forEach(function (id) {
      var p = patterns[id], sum = 0, units = 0;
      for (var j = 0; j < p.length; j++) { if (!runs[offset+j]) return; sum += runs[offset+j].width; units += p[j]; }
      var scale = sum / units, distance = 0;
      for (var k = 0; k < p.length; k++) {
        var d = Math.abs(runs[offset+k].width / scale - p[k]);
        if (d > 0.8) return;
        distance += d;
      }
      distance /= units;
      if (distance < error) { error = distance; best = id; }
    });
    return best;
  }
  function code128(runs) {
    for (var i = 1; i < runs.length-18; i++) {
      if (!runs[i].dark || runs[i-1].width < 8) continue;
      var start = match(runs, i, [103,104,105]);
      if (start === null) continue;
      var codes = [], pos = i+6, stop = false;
      while (pos < runs.length-5 && codes.length < 80) {
        if (match(runs, pos, [106]) === 106) { stop = true; break; }
        var c = match(runs, pos, Array.from({length:103}, function (_, n) { return n; }));
        if (c === null) break;
        codes.push(c); pos += 6;
      }
      if (!stop || codes.length < 2) continue;
      var sum = start;
      for (var x = 0; x < codes.length-1; x++) sum += codes[x]*(x+1);
      if (sum % 103 !== codes[codes.length-1]) continue;
      var set = start-103, value = '', shift = false, valid = true;
      for (var n = 0; n < codes.length-1; n++) {
        var id = codes[n], current = shift ? 1-set : set; shift = false;
        if (current === 2 && id < 100) { value += String(id).padStart(2,'0'); continue; }
        if (id < 96) { value += String.fromCharCode(current === 0 && id >= 64 ? id-64 : id+32); continue; }
        if (id === 99) set = 2;
        else if (id === 100 && set !== 1) set = 1;
        else if (id === 101 && set !== 0) set = 0;
        else if (id === 98 && set !== 2) shift = true;
        else if (id !== 102) { valid = false; break; }
      }
      if (valid && value && !/[\x00-\x1f]/.test(value)) return value;
    }
    return '';
  }
  function checksum(value) {
    var sum = 0;
    for (var i = value.length-2, weight = 3; i >= 0; i--, weight = 4-weight) sum += Number(value[i])*weight;
    return (10-sum%10)%10 === Number(value[value.length-1]);
  }
  function ean(bits, runs) {
    for (var i = 1; i < runs.length-35; i++) {
      if (!runs[i].dark || !runs[i+2].dark) continue;
      var module = (runs[i].width+runs[i+1].width+runs[i+2].width)/3;
      if (module < 0.8 || runs[i-1].width < module*5) continue;
      for (var size of [95,67]) {
        var sampled = '';
        for (var n = 0; n < size; n++) sampled += bits[Math.round(runs[i].start+(n+0.5)*module)] ? '1':'0';
        var count = size === 95 ? 6:4, middle = 3+count*7;
        if (sampled.slice(0,3) !== '101' || sampled.slice(middle,middle+5) !== '01010' || sampled.slice(-3) !== '101') continue;
        var value = '', mode = '', valid = true;
        for (var k = 0; k < count; k++) {
          var group = sampled.slice(3+k*7,10+k*7), digit = left.indexOf(group);
          if (digit >= 0) mode += 'L';
          else { digit = left.map(function (p) { return p.split('').reverse().map(function (b) {return b === '0'?'1':'0';}).join(''); }).indexOf(group); mode += 'G'; }
          if (digit < 0) { valid = false; break; } value += digit;
        }
        if (!valid || (size === 67 && mode !== 'LLLL')) continue;
        if (size === 95) { var first = parity.indexOf(mode); if (first < 0) continue; value = first+value; }
        for (var z = 0; z < count; z++) {
          var right = sampled.slice(middle+5+z*7,middle+12+z*7).split('').map(function (b) {return b === '0'?'1':'0';}).join('');
          var d = left.indexOf(right);
          if (d < 0) { valid = false; break; } value += d;
        }
        if (valid && checksum(value)) return value;
      }
    }
    return '';
  }
  function decodeLine(gray) {
    var min = Math.min.apply(null, gray), max = Math.max.apply(null, gray);
    if (max-min < 50) return '';
    var threshold = (min+max)/2, bits = gray.map(function (v) { return v < threshold; });
    for (var reverse of [false,true]) {
      var scan = reverse ? bits.slice().reverse() : bits, runs = [], start = 0, dark = scan[0];
      for (var x = 1; x <= scan.length; x++) {
        if (x === scan.length || scan[x] !== dark) { runs.push({dark:dark,width:x-start,start:start}); dark=scan[x]; start=x; }
      }
      var result = code128(runs) || ean(scan, runs);
      if (result) return result;
    }
    return '';
  }
  window.ATProductBarcode = {decodeLine:decodeLine, detect:function (image) {
    for (var fraction of [0.5,0.4,0.6,0.3,0.7]) {
      var y = Math.floor(image.height*fraction), gray = [];
      for (var x = 0; x < image.width; x++) {
        var p = (y*image.width+x)*4;
        gray.push((image.data[p]*299+image.data[p+1]*587+image.data[p+2]*114)/1000);
      }
      var value = decodeLine(gray); if (value) return value;
    }
    return '';
  }};
})();
